var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4715 39.4675C31.1761 38.7575 31.1763 37.6062 30.4714 36.8962L13.7023 20.0004L30.4715 3.10389C31.1761 2.39389 31.1763 1.24255 30.4714 0.532552C29.7666 -0.177448 28.6241 -0.177448 27.9195 0.532552L9.87434 18.7149C9.53591 19.0559 9.34585 19.5182 9.34585 20.0004C9.34585 20.4826 9.53607 20.9451 9.87451 21.2861L27.9195 39.4673C28.6242 40.1775 29.7668 40.1775 30.4715 39.4675Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronPrev);
export default __webpack_public_path__ + "static/media/chevron-prev.219c2a078a6449133d5151dad027b99f.svg";
export { ForwardRef as ReactComponent };